import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  schema?: object;
}

export function useSEO({ title, description, keywords, canonical, schema }: SEOProps) {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Update meta tags
    const updateMetaTag = (name: string, content: string) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    if (description) {
      updateMetaTag('description', description);
    }

    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Update canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = `${import.meta.env.VITE_SITE_URL || 'https://example.com'}${canonical}`;
    }

    // Add Schema.org JSON-LD
    if (schema) {
      const scriptId = 'schema-org-jsonld';
      let script = document.getElementById(scriptId);
      
      if (!script) {
        script = document.createElement('script');
        script.id = scriptId;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      
      script.textContent = JSON.stringify(schema);
    }

    return () => {
      // Cleanup schema script on unmount
      if (schema) {
        const script = document.getElementById('schema-org-jsonld');
        if (script) {
          script.remove();
        }
      }
    };
  }, [title, description, keywords, canonical, schema]);
}
